// Estilos de los tipos de puesto (org_chart_node_type.style)
export const NODE_STYLE_DARK = "dark";
export const NODE_STYLE_MEDIUM = "medium";
export const NODE_STYLE_LIGHT = "light";

export const NODE_STYLES = [
  { id: NODE_STYLE_DARK, name: "Oscuro" },
  { id: NODE_STYLE_MEDIUM, name: "Medio" },
  { id: NODE_STYLE_LIGHT, name: "Claro" },
];

// Estilos que se muestran destacados en el organigrama (con cantidad de legajos)
export const PRIMARY_NODE_STYLES = [NODE_STYLE_DARK, NODE_STYLE_MEDIUM];

export const ASSIGNMENT_ALL = "all";

export const DELETE_SUBTEXT = "Sus dependientes pasarán a depender del puesto superior.";
